import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { MDBContainer } from "mdb-react-ui-kit";


const GETDATABYID = "/api/video"

const VideoModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data?.video
                Setcontent(data)

            } else {

                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }


    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Video Details -{content?.videohindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body className="mx-auto">
                    <iframe width="700" height="450" src={`https://www.youtube.com/embed/${content?.videourl}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"  allowfullscreen></iframe>
            </Modal.Body>
        </Modal>
    )
}

export default VideoModal;